import type { JobSalary } from "@lossdog/job-watchlists";
import { useSignals } from "@preact/signals-react/runtime";
import { cx } from "class-variance-authority";

import { ArrowDownIcon } from "@/assets/icons/general/ArrowDown";
import { ArrowUpIcon } from "@/assets/icons/general/ArrowUp";
import { NumberUtils } from "@/util/number.utils";

interface Props {
  jobSalary: JobSalary;
}

export const JobSalaryNetChange = ({ jobSalary }: Props) => {
  useSignals();
  return (
    <span
      className={cx(
        "text-right",
        jobSalary.netChangeUp.value && "animate-salary-flash-up text-info-success",
        jobSalary.netChangeDown.value && "animate-salary-flash-down text-info-error-2",
      )}
    >
      {!!jobSalary.netChangeUp.value && "+"}
      {!!jobSalary.netChangeDown.value && "-"}
      {NumberUtils.formatAsUSCurrency(jobSalary.netChange.value, { useAbsoluteValue: true, showDollarSign: false })}
    </span>
  );
};

export const JobSalaryNetChangeIcon = ({ jobSalary }: Props) => {
  useSignals();
  return (
    <>
      {jobSalary.netChangeUp?.value && <ArrowUpIcon className="h-6 w-6 animate-salary-flash-up text-info-success" />}
      {jobSalary.netChangeDown?.value && (
        <ArrowDownIcon className="h-6 w-6 animate-salary-flash-down text-info-error" />
      )}
    </>
  );
};
